/**
 * Resolve the WebSocket URL with this precedence:
 * 1. `VITE_WS_URL` (explicit override; legacy).
 * 2. Derive from `VITE_API_BASE_URL` by swapping http(s)→ws(s) and appending
 *    `/ws`. Single env var configures both REST and WS.
 * 3. Fallback to `${location.host}/ws` for local dev with a Vite proxy.
 */
export function resolveWsUrl(): string {
  const explicit = import.meta.env.VITE_WS_URL as string | undefined;
  if (explicit) return explicit.endsWith('/ws') ? explicit : `${explicit}/ws`;

  const apiBase = import.meta.env.VITE_API_BASE_URL as string | undefined;
  if (apiBase && /^https?:\/\//i.test(apiBase)) {
    const wsBase = apiBase.replace(/^http/i, 'ws');
    return wsBase.endsWith('/ws') ? wsBase : `${wsBase}/ws`;
  }

  const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${location.host}/ws`;
}
